<table class="table table-striped video-requests"
       *ngIf="requests">
    <thead>
        <tr>
            <th data-cy="requests-title">Title</th>
            <th data-cy="requests-status">Status</th>
            <th data-cy="requests-date" class="hidden-xs">Date</th>
            <th data-cy="requests-from" class="hidden-xs">From</th>
            <th data-cy="requests-to" class="hidden-xs">To</th>
            <th data-cy="requests-site" class="hidden-xs hidden-sm">Site</th>
            <th data-cy="requests-unit" class="hidden-xs hidden-sm">Unit</th>
            <th data-cy="requests-expires" class="hidden-xs">Expires</th>
            <th data-cy="requests-actions">Actions</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let request of requests">
            <tr [ngClass]="{ 'success': request.vrrId === newVrrId }">
                <td data-cy="requests-name" class="overflow-hidden">{{ request.requestName }}</td>
                <td class="with-label">
                    <ng-template #popTemplate>
                        <h3 class="progressTitle">{{ request.videoStatus.replace('Truck', 'Unit') }}</h3>
                        <div class="truckStatusContainer" *ngIf="request.status === 'In Progress' && request.truckIsOffline">
                            <div class="truckStatusCircle truckStatusUnfilled"></div>
                            <div class="truckStatus-text">Unit is offline</div>
                        </div>
                        <div class="progressBar" *ngIf="!request.isError">
                            <ng-container *ngFor="let step of [1,2,3,4,5,6,7,8,9,10]; last as isLast">
                               <div class="barStep" [ngClass]="{'green': request.step == 10, 'blue': request.step >= step && !isLast, 'grey': request.step < step, 'last': isLast}"></div>
                            </ng-container>
                        </div>
                    </ng-template>
                    <span [attr.data-cy]="'requests-status-' + request.requestName"
                          class="label {{ (request.purgedIn <= 0) ? 'label-danger' : request.status === 'In Progress' && request.truckIsOffline ? 'label-gray' : request.status | appStatusLabel }}"
                          [attr.role]="request.isAbandoned || request.isPurged || request.status === 'Rejected' ? undefined : 'button'"
                          [popover]="popTemplate" placement="bottom" [outsideClick]="true"
                          [triggers]="request.isAbandoned || request.isPurged || request.status === 'Rejected' ? '' : 'click'">
                        {{ (request.purgedIn <= 0) ? 'Expired' : (request.status === 'In Progress' && request.truckIsOffline ? 'Offline' : request.status.replace('Truck', 'Unit')) }}
                    </span> 
                </td>
                <td [attr.data-cy]="'requests-date-' + request.requestName"
                    class="hidden-xs nowrap">{{ request.videoFrom | appIsoDateStringMomentFromConfig: 'momentDateFormatMedium' }}</td>
                <td class="hidden-xs nowrap">
                    <span [attr.data-cy]="'requests-from-' + request.requestName"
                          title="{{ request.videoFrom | appIsoDateStringMomentFromConfig: 'momentTimeFormatLong' | lowercase }}">
                        {{ request.videoFrom | appIsoDateStringMomentFromConfig: 'momentTimeFormatMedium' | lowercase }}
                    </span>
                </td>
                <td [attr.data-cy]="'requests-to-' + request.requestName" 
                    class="hidden-xs nowrap">
                    <span title="{{ request.videoTo | appIsoDateStringMomentFromConfig: 'momentTimeFormatLong' | lowercase }}">
                        {{ request.videoTo | appIsoDateStringMomentFromConfig: 'momentTimeFormatMedium' | lowercase }}
                    </span>
                </td>
                <td [attr.data-cy]="'requests-site-number-' + request.requestName" 
                    class="hidden-xs hidden-sm">{{ request.siteNumber }}</td>
                <td [attr.data-cy]="'requests-truck-number-' + request.requestName" 
                    class="hidden-xs hidden-sm">{{ request.truckNumber }}</td>
                <td class="hidden-xs with-label"
                    [ngSwitch]="request.purgedInUnit">
                    <span *ngSwitchCase="'hours'">
                        <span *ngIf="request.purgedIn <= 0" class="label label-danger">Expired</span>
                        <span *ngIf="request.purgedIn > 0">{{ request.purgedIn }} {{ request.purgedInUnit }}</span>
                    </span>
                    <span *ngSwitchDefault>
                        <span *ngIf="request.purgedIn <= 0" class="label label-danger">Expired</span>
                        <span [attr.data-cy]="'requests-expired-' + request.requestName" 
                              class="label label-info"
                              *ngIf="request.purgedIn > 1 && !request.hasTruckResponded"
                              title="Requests will be purged if the unit hasn't responded within this period">{{ request.purgedIn }} {{ request.purgedInUnit }}</span>
                        <span class="label label-success"
                              *ngIf="request.purgedIn > 7 && request.hasTruckResponded">{{ request.purgedIn }} {{ request.purgedInUnit }}</span>
                        <span class="label label-warning"
                              *ngIf="request.purgedIn <= 7 && request.purgedIn > 0 && request.hasTruckResponded">{{ request.purgedIn }} {{ request.purgedInUnit }}</span>
                    </span>
                </td>
                <td>
                    <a [attr.data-cy]="'view-details-' + request.requestName"
                       class="ellipsis nowrap"
                       (click)="showDetails(request)">View Details</a>
                </td>
            </tr>
        </ng-container>
    </tbody>
</table>
